import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'
import ContentHeader from 'component/utils/ContentHeader'
import UseConsumeJustificationTable from 'component/useConsumeJustification/UseConsumeJustificationTable'
import UseConsumeJustificationForm from 'component/useConsumeJustification/UseConsumeJustificationForm'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import * as useConsumeJustificationActions from 'action/useConsumeJustification'

class UseConsumeJustification extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    UseConsumeJustificationFetchList: PropTypes.func.isRequired,
    UseConsumeJustificationUpdate: PropTypes.func.isRequired,
    UseConsumeJustificationRemove: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
  }

  state = {
    justification: { dsUseConsumeJustification: '' },
  }

  componentDidMount() {
    this.handleFetchJustification()
  }

  handleFetchJustification = (page) => {
    const {
      auth: { user },
      UseConsumeJustificationFetchList,
    } = this.props

    UseConsumeJustificationFetchList(user.dsToken, page)
  }

  updateJustificationIsActive = (justification) => {
    const {
      auth: { user },
      UseConsumeJustificationUpdate,
    } = this.props

    const values = {
      ...justification,
      inInactive: justification.inInactive === 0 ? 1 : 0,
    }

    UseConsumeJustificationUpdate(user.dsToken, values)
  }

  saveJustification = (values) => {
    const {
      auth: { user },
      UseConsumeJustificationUpdate,
    } = this.props

    UseConsumeJustificationUpdate(user.dsToken, values)

    this.setState({
      justification: { dsUseConsumeJustification: '' },
    })
  }

  handleEditJustification = (justification) => {
    this.setState({
      justification,
    })
  }

  handleRemoveJustification = (justification) => {
    const {
      auth: { user },
      UseConsumeJustificationRemove,
    } = this.props

    const id = {
      idUseConsumeJustification: justification.idUseConsumeJustification,
    }

    UseConsumeJustificationRemove(user.dsToken, id)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('menu.use.consume') },
      { title: translate('use.consume.justification') },
    ]

    return <Breadcrumb steps={steps} />
  }

  renderPagination = () => {
    const { pages } = this.props

    if (!pages || pages < 2) {
      return null
    }

    const { current, count } = this.props

    return (
      <Col className='align-center margin-top'>
        <Pagination
          getPage={this.handleFetchJustification}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  shouldRenderJustifications = () => {
    const { justifications } = this.props

    if (!justifications || justifications.length < 1) {
      return false
    }

    return true
  }

  render() {
    const { translate, justifications } = this.props
    return (
      <div>
        <ContentHeader>
          {translate('use.consume.justification.title')}
        </ContentHeader>
        {this.renderBreadcrumb()}
        <Grid fluid>
          {' '}
          {/* Use Consume Justification */}
          <Col
            lg={6}
            lgOffset={3}
            md={6}
            mdOffset={3}
            sm={12}
            xs={12}
            className='margin-top'
          >
            <h4>{translate('use.consume.justification.title')}</h4>
          </Col>
          {this.shouldRenderJustifications() && (
            <div>
              <Col
                lg={6}
                lgOffset={3}
                md={6}
                mdOffset={3}
                sm={12}
                xs={12}
                className='align-center margin-top'
              >
                <UseConsumeJustificationTable
                  translate={translate}
                  justifications={justifications}
                  updateJustificationIsActive={this.updateJustificationIsActive}
                  editJustification={this.handleEditJustification}
                  removeJustification={this.handleRemoveJustification}
                />
              </Col>
              {this.renderPagination()}
            </div>
          )}
          <UseConsumeJustificationForm
            updateJustification={this.handleEditJustification}
            justification={this.state.justification}
            translate={translate}
            onSubmit={this.saveJustification}
          />
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({
  useConsumeJustificationReducer,
  paginateReducer,
}) => ({
  justifications: useConsumeJustificationReducer.list.records,
  error: useConsumeJustificationReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(useConsumeJustificationActions, dispatch)

const HomeTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(UseConsumeJustification)

export default connect(mapStateToProps, mapDispatchToProps)(HomeTranslated)

export { UseConsumeJustification }
